import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'

import * as S from './empty-state.styled'

export interface EmptyStateProps {
  title: string
  message: string
}

export const EmptyState = ({ title, message }: EmptyStateProps) => {
  return (
    <S.Container>
      <Icon icon={MagnifyingGlassIcon} size="4rem" />
      <S.Title>{title}</S.Title>
      <S.Message>{message}</S.Message>
    </S.Container>
  )
}
